// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resultDialog img[data-v-317b0c3c]{width:3.64583vw;height:3.64583vw}.resultDialog .tip[data-v-317b0c3c]{display:flex;flex-direction:column;align-items:center;padding:1.04167vw 0 1.19792vw 0}.resultDialog .tip div[data-v-317b0c3c]{line-height:2.08333vw;color:#b9b9b9;font-size:.83333vw}.resultDialog .tip .title[data-v-317b0c3c]{font-size:1.25vw;margin-top:.78125vw;color:#fff}.resultDialog .tip .el-button[data-v-317b0c3c]{color:#fff}.footer[data-v-317b0c3c]{margin-top:.78125vw}", ""]);
// Exports
module.exports = exports;
